import {observer} from "mobx-react";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR} from "../../../../../../components/fonts/font-props";
import {FormField} from "../../../../../../components/form-field/form-field";
import IconCircleBooleanFalse from "../../../../../../components/icons/icon-circle-boolean-false/icon-circle-boolean-false";
import IconCircleBooleanTrue from "../../../../../../components/icons/icon-circle-boolean-true/icon-circle-boolean-true";
import Icon from "../../../../../../components/icons/icon/icon";
import ValidateItemRowEdit from "./validate-item-row-edit";
import ValidateItemRowStore from "./validate-item-row-store";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IValidateItemRowProps {
    store: ValidateItemRowStore,
    disabledAndOff: boolean,
    editMode: boolean
}
const ValidateItemRow : React.FC<IValidateItemRowProps> = observer(({ store, disabledAndOff, editMode })=> {
    const { getTranslation } = useDashboardTranslation();
    const itemValidationPopupScope = 'dashboard-item-validation-popup';

    if((disabledAndOff)){
        return null;
    }
    if(editMode){
        return <ValidateItemRowEdit store={store}/>;
    }
    return (
        <div className={'validate-item-row'}>
            <div className={'validate-item-row-text'}>
                <div className={'validate-item-icon'}>
                    <Icon Component={store.icon} color={'var(--color-accent-1)'}/>
                </div>
                <div className={'validate-item-label'}>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}>{getTranslation(store.label, itemValidationPopupScope)}</FontBody2>
                </div>
                <div className={'validate-item-bool'}>
                    <Icon Component={store.isChecked ? IconCircleBooleanTrue : IconCircleBooleanFalse} />
                </div>
            </div>
            
            {!!store.comment.length &&
                <div className={'validate-item-row-comment'}>
                    <FormField label={'Why not?'}>
                        <FontBody1 color={FONT_COLOR.PRIMARY3_50}>{store.comment}</FontBody1>
                    </FormField>
                </div>
            }
            
            
        </div>
    )
});

export default ValidateItemRow;